import type { PurchaseWebContract } from '@xing-com/crate-common-graphql-types';

/** Selects the contract used as the default offer on the purchase page. */
export const getDefaultContract = (
  contracts: PurchaseWebContract[]
): PurchaseWebContract => {
  if (contracts.length === 0) {
    throw new Error('No contracts available');
  }

  return contracts.reduce((defaultContract, contract) =>
    contract.initialDuration > defaultContract.initialDuration
      ? contract
      : defaultContract
  );
};
